import React, { useState, useEffect, useRef } from "react";
import "../Css/Home.css";
import Nav from "../Utils/Nav"
import Footer from "../Utils/Footer"
import slid1 from "../Assets/slid1.png";
import slid2 from "../Assets/slid2.png";
import slid3 from "../Assets/slid3.png";
import hod from "../Assets/hod-civil.png";
import rightarrow from "../Assets/right-arrow.png";
import rank from "../Assets/rank.png";
import ug from "../Assets/ug.png";
import pg from "../Assets/pg.png";
import dg from "../Assets/dp.png";
import updown from "../Assets/updown.png";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const data = [
  {
    img: slid1,
  },
  {
    img: slid2,
    // img: slid2,
  },
  {
    img: slid3,
  },
];

export default function Home() {
  // ----------BUTTON TO CHANGE DIV--------
  const [showtab, setshowtab] = useState(1);
  const handletab = (e) => {
    setshowtab(e);
  };

  const PrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-prev-arrow`}
        style={{
          ...style,
          left: "3px",
          top: "250px",
          zIndex: 1,
          // background: 'rgba(0, 0, 0, 0.5)', // Optional: make arrow background dark
          borderRadius: "50%",
          padding: "10px",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <span style={{ color: "white", fontSize: "18px" }}></span>
      </div>
    );
  };

  const NextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} custom-next-arrow`}
        style={{
          ...style,
          right: "24px",
          top: "250px",
          zIndex: 1,
          // background: 'rgba(0, 0, 0, 0.5)', // Optional: make arrow background dark
          borderRadius: "50%",
          padding: "10px",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <span style={{ color: "white", fontSize: "18px" }}></span>
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6500,
    pauseOnHover: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  // news and event section

  const items = [
    {
      title: "Two Days National Brainstorming Session",
      description:
        "Dr. Naveen James was invited to Two Days National Brainstorming Session on Development of Early Warning System for Landslide Mitigation at IIT BHU, organized by DST-NRDMS, 19th to 20th July 2019.",
    },
    {
      title: "Mr. Akshar Tripathi received the Best Paper Award for his paper",
      description:
        "Mr. Akshar Tripathi received the Best Paper Award for his paper titled “C-band SAR Interferometry based flood inundation mapping for Gorakhpur and adjoining areas”. In ICCECE, October 2019, Kolkata.",
    },
    {
      title: "The Best Paper Award to Mr. Safdar Naveed Amini",
      description:
        "Mr. Safdar Naveen Amini received the “Best Paper Award” on the 7th. International Conference for Civil, Structural and Transportation Engineering (ICCSTE’22) held in Canada in June 2022. He presented his work on “Effect of Corrosion and Transverse Reinforcement on Flexural Response of 3D Finite Element Reinforced Concrete Beams”",
    },
    {
      title: "Best Presentation Award for Ms. Shreya Ganguly",
      description:
        "Best Presentation Award for Ms. Shreya Ganguly at the Hydro International Conference 2021 hosted by SVNIT Surat (Online)”",
    },
   
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleScrollUp = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  return (
    <>
      <Nav/>
      <div className="main-container">
        <div className="banner-h">
          <Slider {...settings}>
            {data.map((d, index) => (
              <div className="background-h" key={index}>
                <img src={d.img} alt={`Slide ${index + 1}`} />
              </div>
            ))}
          </Slider>
        </div>

        {/*----------------middlesection----------------------  */}

        <div className="middle-section">
          <div className="middle-content">
            <div className="left-section">
              <div className="left-content">
                <p style={{ textAlign: "left" }} className="left-h">
                  Welcome to <br /> Department of Civil Engineering
                </p>
                <div className="left-content-para">
                  <p>
                    The Civil Engineering department came into existence in 2016
                    in a rather modest way with three faculty members, 25
                    B.Tech.Students, and one Ph.D. student. The Department has
                    evolved significantly since then on all fronts. The faculty
                    strength has risen to 15, and the number of B.Tech.Students
                    have increased to 158, and the number of Ph.D. scholars in
                    the Department has been increased to 55. The Department has
                    also started two years of master’s programs to offer M.Tech.
                    in Water Resources and Environment and M.Tech. in Structural
                    Engineering and Geomechanics. The Department has
                    commissioned multiple basic academic laboratories and
                    advanced research laboratories. The Department is actively
                    engaged in industrial collaboration through research and
                    consultancy projects with various government and private
                    industries.
                  </p>

                  <h2 className="inner-h">Vision</h2>

                  <p>
                    To be a world-renowned civil engineering department with a
                    commitment to producing erudite engineers and executing
                    transformative research.
                  </p>

                  <h2 className="inner-h">Mission</h2>

                  <p>
                    “To foster a transformative learning environment and a
                    culture of excellence enabling creation of knowledge and
                    development of socially responsible, enterprising leaders
                    contributing significantly to national progress and
                    humanity.”
                  </p>

                  <h2 className="inner-h">Goals</h2>
                  <p>
                    <ul className="left-content-para-ul">
                      <li>
                        Educate the next generation of Civil Engineers who are
                        capable of critical thinking to tackle unorthodox
                        challenges in the field of Civil Engineering.
                      </li>
                      <li>
                        Tailor effective course contents and teaching
                        methodologies to cover the fundamental aspects of the
                        Civil Engineering discipline.
                      </li>
                      <li>
                        Conduct cutting-edge research in modern structural
                        materials, new analysis and design methodologies,
                        modelling and simulation, and addressing environmental
                        issues.
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>

            <div className="right-section">
              <div className="right-content">
                <h2 style={{ textAlign: "left" }} className="right-h">
                  News & Announcements
                </h2>
                <button className="arrow" onClick={handleScrollUp}>
                  <img src={updown} alt="" />
                </button>
                <div className="right-content-para">
                  <ul className="right-content-ul">
                    {items.map((item, index) => (
                      <li
                        key={index}
                        style={{
                          transform: `translateY(-${currentIndex * 210}px)`, // Assuming each <li> has a height of 210px
                          transition: "transform 0.5s ease",
                        }}
                      >
                        <h2 className="right-content-h">{item.title}</h2>
                        {item.description}
                      </li>
                    ))}

                    {/* <li>
                    <h2 className="right-content-h">
                      Two Days National Brainstorming Session
                    </h2>
                    Dr. Naveen James was invited to Two Days National
                    Brainstorming Session on Development of Early Warning System
                    for Landslide Mitigation at IIT BHU, organized by DST-NRDMS,
                    19th to 20th July 2019.
                  </li>
                  <li>
                    <h2 className="right-content-h">
                      Mr. Akshar Tripathi received the Best Paper Award for his
                      paper
                    </h2>
                    Mr. Akshar Tripathi received the Best Paper Award for his
                    paper titled “C-band SAR Interferometry based flood
                    inundation mapping for Gorakhpur and adjoining areas”. In
                    ICCECE, October 2019, Kolkata.
                  </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* -------------hod ------------------ */}

          <div className="hod-information">
            <div className="hod-content">
              <div className="hod-img">
                <img src={hod} alt="" />
              </div>

              <div className="hod-info">
                <h1 style={{ paddingBottom: "10px" }}>Message from HOD</h1>
                <p className="black">Dr. Sagar Rohidas Chavan</p>
                <p className="black" style={{ paddingBottom: "10px" }}>
                  Associate Professor & Head
                </p>

                <p style={{ paddingBottom: "10px" }}>
                  Welcome to the Department of Civil Engineering!
                </p>

                <p style={{ marginBottom: "20px", textAlign: "justify" }}>
                  The Department of Civil Engineering was established on 1st
                  July 2016 with a vision to be a world-renowned department
                  having commitment towards producing erudite engineers and
                  executing transformative research. The Department is young
                  with vibrant and energetic faculty members, constantly
                  striving to do their best in teaching and research. The
                  Department now has state-of-the-art laboratories, facilitating
                  UG-PG teaching and research. The B. Tech. Civil Engineering
                  curriculum is carefully designed to prepare the students for
                  critical thinking and to tackle unorthodox challenges in the
                  field of Civil Engineering. The Department is fully committed
                  to train and transforming the UG students into able
                  professionals who are ready to contribute to the
                  nation-building.
                </p>

                <a href="">
                  <button className="hod-btn">
                    Read More <img src={rightarrow} alt="" />
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* -----------------color div------------------- */}

          <div className="color-div">
            <h1 className="color-h">IIT Ropar Civil Engineering AT-A-GLANCE</h1>

            <div className="box-container">
              <div className="box">
                <div className="box-img">
                  <img src={rank} alt="" />
                </div>
                <div className="box-content">
                  <p>
                    Ranked 86th as per The World University Ranking Ranked 31st
                    as per NIRF
                  </p>
                </div>
              </div>

              <div className="box">
                <div className="box-img">
                  <img src={rank} alt="" />
                </div>
                <div className="box-content">
                  <p>
                    Ranked 86th as per The World University Ranking Ranked 31st
                    as per NIRF
                  </p>
                </div>
              </div>

              <div className="box">
                <div className="box-img">
                  <img src={rank} alt="" />
                </div>
                <div className="box-content">
                  <p>
                    Ranked 86th as per The World University Ranking Ranked 31st
                    as per NIRF
                  </p>
                </div>
              </div>

              <div className="box">
                <div className="box-img">
                  <img src={rank} alt="" />
                </div>
                <div className="box-content">
                  <p>
                    Ranked 86th as per The World University Ranking Ranked 31st
                    as per NIRF
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* --------------events-------------- */}

          <div className="events">
            <h1 className="eve-h" style={{textAlign:"center"}}>Upcoming & Completed Events</h1>

            <div className="event-box">
              <div className="event-box-content">
                <h2>Workshop on Open Roads Software</h2>
                <p>4-year B-Tech program in Civil Engineering</p>
              </div>
              <div className="event-box-content">
                <h2>Functional Development Program for SJVN Executives</h2>
                <p>4-year B-Tech program in Civil Engineering</p>
              </div>
              <div className="event-box-content">
                <h2>
                  Expert Talk on “Smart Water Systems – Enabling Sustainable
                  Water Supply” by Prof. Mohan Kumar
                </h2>
                <p>4-year B-Tech program in Civil Engineering</p>
              </div>
            </div>

            <div className="more-event">
              <h2 style={{textAlign:"center"}}>
                <a href="">View All Our Events</a>
              </h2>
            </div>
          </div>

          {/* ----------------academics------------  */}

          <div className="academics">
            <div className="dark"></div>

            <div className="acad-content">
              <h1>Academics</h1>

              <p className="acad-p">
                Our Graduates go on to work at the forefront of the world's most
                vital infrastructure projects in pursuit of a smart and
                sustainable future.
              </p>

              <div className="acad-box">
                <div className="acad-box-content">
                  <img src={ug} alt="" />
                  <p>4-year B-Tech program in Civil Engineering</p>
                </div>
                <div className="acad-box-content">
                  <img src={pg} alt="" />
                  <p>
                    2-year M-Tech program in Water Resources and Environment
                  </p>
                </div>
                <div className="acad-box-content">
                  <img src={dg} alt="" />
                  <p>PhD program in all major streams of Civil Engineering</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    <Footer/>  
    </>
  );
}
